import { useFetch, useFetch2 } from "./util";

type FindAllType = {
  offset: number;
  limit: number;
  name?: string;
};

type FindAllCompanyItem = {
  id: number;
  name: string;
  plataformName: string;
  active: boolean;
  pipeline: boolean;
  calendar: boolean;
};

type FindAllCompanyResponse = {
  result: FindAllCompanyItem[];
  total: number;
};

export default () => {
  const setup = useFetch("/api/setup", { method: "POST" });
  const resendEmail = useFetch("/api/setup/resend-email", { method: "POST" });
  const findAll = useFetch2();

  return {
    setup,
    resendEmail,
    findAll: async (input: FindAllType): Promise<FindAllCompanyResponse> => {
      try {
        const paramRequest = new URLSearchParams(
          input.name
            ? {
                offset: `${input.offset}`,
                limit: `${input.limit}`,
                name: input.name
              }
            : {
                offset: `${input.offset}`,
                limit: `${input.limit}`
              }
        );

        return findAll<FindAllCompanyResponse>(`/api/companies?${paramRequest}`, {
          method: "GET"
        });
      } catch (error) {
        return error;
      }
    }
  };
};
